module.exports = __webpack_public_path__ + "media/images/photos/key-fob-22dd3de17fc70b24156688cbe229a61b.jpg";